// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"q4-z","displaySixCardTiles":"r4-z"};